import { GridFilterOperator } from '@mui/x-data-grid-pro'

import { Autocomplete } from '@collaborate-health/uikit'
import { GetQualificationResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'

import { useAllCertificateTypes } from '../../hooks'
import { CertificateType } from '../../types'

const CertificateTypeGridFilterOperator: GridFilterOperator<GetQualificationResponse>['InputComponent'] = ({
  item,
  applyValue,
  personal = false,
}) => {
  const filterValue: CertificateType[] = item.value ?? []

  const { loading: certificateTypesLoading, certificateTypes } = useAllCertificateTypes({
    showCurrentUserCertificates: personal,
  })

  return (
    <Autocomplete
      size='small'
      disabled={certificateTypesLoading}
      loading={certificateTypesLoading}
      multiple
      fullWidth
      value={filterValue}
      options={certificateTypes}
      getOptionKey={(option) => option.Id}
      getOptionLabel={(option) => option.Name}
      label='Types'
      isOptionEqualToValue={(option, value) => option.Id === value.Id}
      onChange={(event, newValues) => {
        applyValue({
          ...item,
          value: newValues ?? [],
        })
      }}
    />
  )
}

export default CertificateTypeGridFilterOperator

